import { render } from "./FilterIndikatorGroupUniversal.vue?vue&type=template&id=17552782&ts=true"
import script from "./FilterIndikatorGroupUniversal.vue?vue&type=script&lang=ts"
export * from "./FilterIndikatorGroupUniversal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__